import React, { Component } from 'react';
import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';

const Item = styled.div`
    width: 22.5%;
    background: ${ COLORS.white };
    border: 1px solid ${ COLORS.outlineGrey };
    border-radius: 8px;
    padding: 53px 0 42px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 16px;

    @media(max-width: 1919px) {
        width: 49%;
        margin: 0 0 22px;
        flex-direction: row;
        align-items: flex-start;
        flex-flow: row;
        padding: 29px 29px 40px 42px;
    }

    @media(max-width: 1365px) {
        padding: 29px 28px 35px;
        margin: 0 0 12px 6px;
    }

    @media(max-width: 1023px) {
        width: 47%;
        flex-wrap: wrap;
        margin: 0 8px 24px;
        padding: 41px 28px 55px;
        align-items: center;
        flex-direction: column;
    }

    @media(max-width: 767px) {
        width: 100%;
        margin: 0 0 18px;
        align-items: center;
        flex-direction: column;
        padding: 45px 13px 40px;
    }
`;

const Icon = styled.div`
    width: 80px;
    height: 80px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    @media(max-width: 1919px) {
        width: 100px;
        height: 100px;
        margin-right: 38px;
    }

    @media(max-width: 1365px) {
        width: 67px;
        height: 67px;
        margin-right: 21px;
    }

    @media(max-width: 1023px) {
        margin-right: 0;
    }

    @media(max-width: 767px) {
        margin-right: 0;
    }
`;

const ItemText = styled.div`
    width: 85%;
    justify-content: center;

    @media(max-width: 1919px) {
        justify-content: flex-start;
    }

    @media(max-width: 1023px) {
        justify-content: center;
    }
`;

const ItemTitle = styled.div`
    ${FONTS.L};
    color: ${ COLORS.black };
    margin-top: 31px;
    text-align: center;

    @media(max-width: 1919px) {
        text-align: left;
        margin-top: 13px;
    }

    @media(max-width: 1365px) {
        margin-top: 10px;
        ${FONTS.S};
    }

    @media(max-width: 1023px) {
        text-align: center;
        margin-top: 8px;
    }

    @media(max-width: 767px) {
        ${FONTS.L};
        margin-top: 18px;
    }
`;

const ItemDesc = styled.div`
    ${FONTS.S};
    color: ${ COLORS.black };
    margin-top: 8px;
    text-align: center;
    padding: 0 8px;

    @media(max-width: 1919px) {
        text-align: left;
        margin-top: 3px;
        padding: 0;
    }

    @media(max-width: 1365px) {
        margin-top: 1px;
        ${FONTS.XXS};
        padding: 0;
    }

    @media(max-width: 1023px) {
        margin-top: 12px;
        text-align: center;
        padding: 0 8px;
        ${FONTS.S};
    }

    @media(max-width: 767px) {
        ${FONTS.S};
        margin-top: 4px;
        padding: 0;
    }
`;

export default class SectionServicesItem extends Component {
    render() {
        const { icon, title, desc } = this.props;

        return (
            <Item>
                <Icon>
                    <img src={icon} alt={title}/>
                </Icon>
                <ItemText>
                    <ItemTitle as='h3'>{title}</ItemTitle>
                    <ItemDesc as='p'>{desc}</ItemDesc>
                </ItemText>
            </Item>
        );
    }
}
